import { GoogleMap, InfoWindowF, Marker, MarkerClusterer, MarkerF } from '@react-google-maps/api';
import { Clusterer } from '@react-google-maps/marker-clusterer';
import { withBasePath } from '@src/common/pathConvert';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { MapAddress } from 'src/common/models/branchmap';
import { useGoogleMapScript } from 'src/hooks/useGoogleMapScript';

type Props = {
    addressList: MapAddress[];
    showAddressInfo?: boolean;
    selectedIndex?: number;
    onSelectedChange?: (index?: number) => void;
};

function AppGoogleMap({ addressList, showAddressInfo, selectedIndex, onSelectedChange }: Props) {
    const { isLoaded } = useGoogleMapScript();
    const [map, setMap] = useState<google.maps.Map>();
    const clusterRef = useRef<Clusterer>();
    const defaultMarkerIcon = useRef<google.maps.Icon>();
    const selectedMarkerIcon = useRef<google.maps.Icon>();

    const [selectedAddress, setSelectedAddress] = useState<{
        address: MapAddress;
        marker: google.maps.Marker;
    } | null>();

    useEffect(() => {
        if (map && addressList && addressList.length) {
            var bounds = new google.maps.LatLngBounds();
            for (const branch of addressList) {
                bounds.extend(branch);
            }
            if (map) {
                map.fitBounds(bounds);
            }
        }
        setSelectedAddress(null);
    }, [map, addressList]);
    useEffect(() => {
        if (clusterRef.current) {
            defaultMarkerIcon.current ??= {
                url: withBasePath(`/images/spotlight-poi3.png`),
                scaledSize: new google.maps.Size(26, 26 * 1.423),
            };
            selectedMarkerIcon.current ??= {
                url: withBasePath(`/images/spotlight-poi3.png`),
                scaledSize: new google.maps.Size(32, 32 * 1.423),
            };
            clusterRef.current.markers.forEach((marker, index) => {
                if (selectedIndex === index) {
                    marker.setIcon(selectedMarkerIcon.current);
                } else {
                    marker.setIcon(defaultMarkerIcon.current);
                }
            });
        }
    }, [selectedIndex]);
    const onLoad = useCallback((map: google.maps.Map) => {
        setMap(map);
    }, []);
    return (
        <div className='w-full aspect-video '>
            {isLoaded ? (
                <GoogleMap mapContainerClassName='w-full h-full' onLoad={onLoad}>
                    <MarkerClusterer
                        minimumClusterSize={Number.MAX_SAFE_INTEGER}
                        onLoad={(cluster) => {
                            clusterRef.current = cluster;
                        }}
                    >
                        {(cluster) => {
                            const markers = addressList?.map((b, index) => {
                                return (
                                    <MarkerF
                                        key={index}
                                        position={b}
                                        clusterer={cluster}
                                        onLoad={(marker) => {
                                            showAddressInfo &&
                                                marker.addListener('click', () => {
                                                    marker
                                                        .getMap()
                                                        ?.setOptions({ center: b, zoom: 16 });
                                                    setSelectedAddress({
                                                        address: b,
                                                        marker: marker,
                                                    });
                                                });
                                        }}
                                        onMouseOver={() => {
                                            onSelectedChange && onSelectedChange(index);
                                        }}
                                        onMouseOut={() => {
                                            onSelectedChange && onSelectedChange();
                                        }}
                                    ></MarkerF>
                                );
                            });
                            return <>{markers}</>;
                        }}
                    </MarkerClusterer>

                    {selectedAddress && (
                        <InfoWindowF
                            position={selectedAddress.address}
                            anchor={selectedAddress.marker}
                            onCloseClick={() => {
                                setSelectedAddress(null);
                            }}
                        >
                            <div>
                                <div
                                    style={{ fontSize: '14px', color: '#666', fontWeight: 'bold' }}
                                >
                                    {selectedAddress.address.name}
                                </div>
                                <div style={{ width: '270px', color: '#666' }}>
                                    {selectedAddress.address.address}
                                </div>
                                <img
                                    className='mt-5 '
                                    src={selectedAddress.address.image}
                                    alt=''
                                ></img>
                            </div>
                        </InfoWindowF>
                    )}
                </GoogleMap>
            ) : (
                <></>
            )}
        </div>
    );
}

export default memo(AppGoogleMap);
